<template>
  <div v-if="file && type">
    <p>
      <v-btn :to="backLink">
        <v-icon>chevron_left</v-icon>Change Entry type
      </v-btn>
    </p>
    <h1>Entry search</h1>
    <FileWorking :file="file" />
    <h2>{{ type.name }}</h2>
    <v-alert :value="true" type="info">
      Search for the entity using the table below. Click "File" button to add
      the entry to the address book for the selected file. Click "File &amp;
      Related" button to add the entry to the address book for the file and its
      related matter. Click "Record" button to view the entity record.
    </v-alert>
    <v-expansion-panel v-model="panel" expand>
      <v-expansion-panel-content>
        <template v-slot:header>
          <h2><v-icon>search</v-icon>Filter Records</h2>
        </template>
        <v-card>
          <v-card-text>
            <v-container fluid grid-list-md>
              <v-layout row wrap>
                <v-flex xs12 md6 v-if="type.company">
                  <v-text-field v-model="filters.name" label="Name" outline />
                </v-flex>
                <v-flex xs12 md6 v-if="type.person">
                  <v-text-field
                    v-model="filters.forename"
                    label="Forename"
                    outline
                  />
                </v-flex>
                <v-flex xs12 md6 v-if="type.person">
                  <v-text-field
                    v-model="filters.surname"
                    label="Surname"
                    outline
                  />
                </v-flex>
                <v-flex xs12 md6 v-if="type.person">
                  <v-text-field v-model="filters.email" label="Email" outline />
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="filters.address"
                    label="Address"
                    outline
                  />
                </v-flex>
                <!-- <v-flex xs12 md6 v-if="type.person">
                <v-text-field v-model="filters.dob" label="Date of birth" outline />
                </v-flex>-->
              </v-layout>
            </v-container>
            <v-btn @click="searchFilters">
              <v-icon>search</v-icon>Search
            </v-btn>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <br />
    <v-data-table
      :pagination.sync="pagination"
      :total-items="suggestionCount"
      :loading="loading"
      :headers="headersPerson"
      :items="suggestions"
      :footer-props="{ showFirstLastPage, showCurrentPage }"
      class="elevation-1"
      v-if="type.person"
    >
      <template v-slot:items="props">
        <tr>
          <td>{{ props.item.forename }}</td>
          <td>{{ props.item.surname }}</td>
          <td>{{ props.item.email }}</td>
          <td>{{ props.item.address }}</td>
          <td>{{ props.item.dateOfBirth }}</td>
          <td>
            <SuggestionLink
              :file="file"
              :suggestion="props.item"
              :showCopy="showCopy"
            />
          </td>
        </tr>
      </template>
    </v-data-table>
    <v-data-table
      :pagination.sync="pagination"
      :total-items="suggestionCount"
      :loading="loading"
      :headers="headersCompany"
      :items="suggestions"
      :footer-props="{ showFirstLastPage, showCurrentPage }"
      class="elevation-1"
      v-if="type.company"
    >
      <template v-slot:items="props">
        <tr>
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.address }}</td>
          <td>
            <SuggestionLink
              :file="file"
              :suggestion="props.item"
              :showCopy="showCopy"
            />
          </td>
        </tr>
      </template>
    </v-data-table>
    <p v-if="type.entrySearchAdd">
      <v-alert :value="true" type="info"
        >Not in list? If you have searched and cannot find the entity, then you
        can use the button(s) below to create a new entity.</v-alert
      >
      <v-btn :to="computedCreateEntityLink">
        <v-icon>add</v-icon>Entry file
      </v-btn>
    </p>
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
import FileWorking from "@/components/link/FileWorking";
import SuggestionLink from "@/components/directory/entrySearch/SuggestionLink";
export default {
  name: "EntrySearch",
  metaInfo() {
    return {
      title: "Entry search",
      titleTemplate: "%s - Directory - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  components: {
    FileWorking,
    SuggestionLink
  },
  computed: {
    backLink() {
      return {
        name: "entryType",
        params: {
          objectType: this.$route.params.objectType,
          objectId: this.$route.params.objectId,
          ...(this.file.relatedId
            ? {
                relatedId: this.file.relatedId
              }
            : {})
        }
      };
    },
    showCopy() {
      if (
        this.file.relatedId &&
        (this.$route.params.typeId == 3 || this.$route.params.typeId == 4)
      ) {
        return true;
      } else {
        return false;
      }
    },
    computedCreateEntityLink() {
      return {
        name: "entityCreate",
        params: {
          id: this.$route.params.typeId
        },
        query: {
          fileid: this.$route.params.objectId
        }
      };
    }
  },
  data() {
    return {
      file: null,
      type: null,
      headersPerson: [
        {
          text: "Forename",
          value: "forename"
        },
        {
          text: "Surname",
          value: "surname"
        },
        {
          text: "Email",
          value: "email"
        },
        {
          text: "Address",
          value: "address"
        },
        {
          text: "Date of birth",
          value: "dob"
        },
        {
          text: " ",
          value: "id"
        }
      ],
      headersCompany: [
        {
          text: "Name",
          value: "name"
        },
        {
          text: "Address",
          value: "address"
        },
        {
          text: " ",
          value: "id"
        }
      ],
      suggestionCount: 0,
      suggestions: [],
      filters: {
        sortBy: null,
        descending: null,
        name: null,
        forename: null,
        surname: null,
        email: null,
        address: null,
        dob: null
      },
      loading: false,
      pagination: {
        page: 1,
        rowsPerPage: 10
      },
      showFirstLastPage: true,
      showCurrentPage: true,
      panel: []
    };
  },
  methods: {
    async fetchFile() {
      const response = await nbmlaw.get(
        `/cors/admin/file/files/${this.$route.params.objectId}`
      );
      // console.log(response.data);
      this.file = response.data;
    },
    async fetchType() {
      const response = await nbmlaw.get(
        `/cors/admin/directory/types/${this.$route.params.typeId}`
      );
      // console.log(response.data);
      this.type = response.data;
    },
    async fetchSuggestionsCount() {
      const response = await nbmlaw.post(
        `/cors/admin/directory/types/${this.$route.params.typeId}/suggestions/count`,
        this.filters
      );
      // console.log(response.data);
      this.suggestionCount = response.data;
    },
    async fetchSuggestions() {
      const { sortBy, descending, page, rowsPerPage } = this.pagination;
      if (rowsPerPage != -1) {
        // console.log("sort by: " + sortBy + ", sort descending: " + descending);
        let firstRow = (page - 1) * rowsPerPage;
        // console.log("type id: " + this.$route.params.typeId + ", firstRow: " + firstRow + ", rowsPerPage: " + rowsPerPage);
        this.filters.sortBy = sortBy;
        this.filters.descending = descending;
        const response = await nbmlaw.post(
          `/cors/admin/directory/types/${this.$route.params.typeId}/suggestions/${firstRow}/${rowsPerPage}`,
          this.filters
        );
        // console.log(response.data);
        this.suggestions = response.data;
        this.loading = false;
      } else {
        this.pagination.rowsPerPage = 10;
      }
    },
    update() {
      this.loading = true;
      this.fetchSuggestionsCount();
      this.fetchSuggestions();
    },
    searchFilters() {
      this.pagination.page = 1;
      this.update();
    }
  },
  watch: {
    "$route.params.typeId": {
      immediate: true,
      handler() {
        this.fetchType();
        this.fetchFile();
        this.update();
      }
    },
    pagination: {
      handler() {
        this.update();
      },
      deep: true
    },
    type: {
      handler() {
        this.panel[0] = this.type.entrySearchSearch;
      }
    }
  }
};
</script>
